module.exports = __webpack_public_path__ + "img/splashArt-01.5d26f22e.png";